var _defs, _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKasa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d2451;}.cls-2{fill:#fff;}.cls-3{fill:#ffc947;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8,
    cy: 8,
    r: 7.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.76,9.21a5.07,5.07,0,0,0,1.57-3.73A.32.32,0,0,0,10,5.15H9a.32.32,0,0,0-.32.3C8.59,8,7.1,8.39,7.1,8.39V5.49a.32.32,0,0,0-.32-.32h-1a.32.32,0,0,0-.32.32V9.71a.46.46,0,0,0,.42.51h.89a1.43,1.43,0,0,1,1,.35,2.92,2.92,0,0,1,1,2.4.32.32,0,0,0,.32.3h1a.32.32,0,0,0,.32-.33A5.07,5.07,0,0,0,8.76,9.21Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.88,
    cy: 3.38,
    r: 1.04
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKasa);
export default __webpack_public_path__ + "static/media/kasa.21d96be730d4adb0163eb14c2822c843.svg";
export { ForwardRef as ReactComponent };